import React from "react";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { convertStringToArray } from "../../../Utils/utils";

const VideoGallery = ({ data }) => {
  const { getText } = useLanguageTranslation();
  // convert video string into array
  const videoGalleryData = convertStringToArray(data);

  return (
    <>
      <div className="title-sec">
        <h4> {getText("Video Gallery", "वीडियो गैलरी")}</h4>
      </div>
      <div className="row">
        {videoGalleryData.length > 0 ? (
          videoGalleryData.map((item, index) => (
            <div
              className="col-12 col-sm-12 col-md-6 col-lg-4 mvDescWrap mb-3"
              key={index}
            >
              <div className="photo-gallery-area video-card">
                <div className="card-sec">
                  <div className="img-sec">
                    <video
                      width="100%"
                      height="auto%"
                      controls={true}
                      // autoPlay={true}
                      loop={true}
                      muted={true}
                    >
                      <source
                        src={`${process.env.REACT_APP_IMAGE_URL}/neepco/sites/default/files/2024-08/${item.file_path}`}
                        type="video/mp4"
                      />
                    </video>
                  </div>
                  {/* <div className="desc-sec">
                  <p>{item.title}</p>
                </div> */}
                </div>
              </div>
            </div>
          ))
        ) : (
          <h4 className="title4">
            {getText("No Video available", "कोई वीडियो उपलब्ध नहीं")}
          </h4>
        )}
      </div>
    </>
  );
};

export default VideoGallery;
